/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AdminRuleTestSettingsDto } from '../model/adminRuleTestSettingsDto';
import { AdminRuleTestSettingsRequestDto } from '../model/adminRuleTestSettingsRequestDto';
import { AdminRuleTestUserDto } from '../model/adminRuleTestUserDto';
import { AdminRuleTestUserLimitRequestDto } from '../model/adminRuleTestUserLimitRequestDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AdminRuleTestManagementService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Standard-Tageslimit abrufen
     * Wirksamer Standard, im Admin Center gesetzter Wert und Server-Vorgabe
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSettings(observe?: 'body', reportProgress?: boolean): Observable<AdminRuleTestSettingsDto>;
    public getSettings(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminRuleTestSettingsDto>>;
    public getSettings(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminRuleTestSettingsDto>>;
    public getSettings(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminRuleTestSettingsDto>('get',`${this.basePath}/admin/rule-tests/settings`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Testlaeufe eines Nutzers abrufen
     * Wirksames Limit samt Herkunft, heutiger Verbrauch und die letzten 7 Tage
     * @param userId Benutzer ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUser(userId: number, observe?: 'body', reportProgress?: boolean): Observable<AdminRuleTestUserDto>;
    public getUser(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminRuleTestUserDto>>;
    public getUser(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminRuleTestUserDto>>;
    public getUser(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getUser.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminRuleTestUserDto>('get',`${this.basePath}/admin/rule-tests/users/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Heutigen Verbrauch zuruecksetzen
     * Setzt den Zaehler des heutigen Tages auf 0; fruehere Tage bleiben unveraendert
     * @param userId Benutzer ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetUsage(userId: number, observe?: 'body', reportProgress?: boolean): Observable<AdminRuleTestUserDto>;
    public resetUsage(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminRuleTestUserDto>>;
    public resetUsage(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminRuleTestUserDto>>;
    public resetUsage(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling resetUsage.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminRuleTestUserDto>('post',`${this.basePath}/admin/rule-tests/users/${encodeURIComponent(String(userId))}/reset-usage`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Standard-Tageslimit setzen
     * Gilt fuer alle Nutzer ohne eigenes Limit. null &#x3D; Server-Vorgabe verwenden; erlaubt 0 bis 1000.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateSettings(body?: AdminRuleTestSettingsRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AdminRuleTestSettingsDto>;
    public updateSettings(body?: AdminRuleTestSettingsRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminRuleTestSettingsDto>>;
    public updateSettings(body?: AdminRuleTestSettingsRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminRuleTestSettingsDto>>;
    public updateSettings(body?: AdminRuleTestSettingsRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminRuleTestSettingsDto>('put',`${this.basePath}/admin/rule-tests/settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Eigenes Tageslimit eines Nutzers setzen
     * null &#x3D; Standard verwenden, 0 &#x3D; Testlaeufe sperren; erlaubt 0 bis 1000
     * @param userId Benutzer ID
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUserLimit(userId: number, body?: AdminRuleTestUserLimitRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AdminRuleTestUserDto>;
    public updateUserLimit(userId: number, body?: AdminRuleTestUserLimitRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminRuleTestUserDto>>;
    public updateUserLimit(userId: number, body?: AdminRuleTestUserLimitRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminRuleTestUserDto>>;
    public updateUserLimit(userId: number, body?: AdminRuleTestUserLimitRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling updateUserLimit.');
        }


        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminRuleTestUserDto>('put',`${this.basePath}/admin/rule-tests/users/${encodeURIComponent(String(userId))}/limit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
